export const sanitizeInputText = (s: string) => {
  return s
    .replace(/\u2028|\u2029/g, '\n') // line/para sep -> newline
    .replace(
      /[\u200B-\u200D\uFEFF\u200E\u200F\u061C\u202A-\u202E\u2066-\u2069]/g,
      '',
    ) // zero-width-spaces/BOM
}
